import React from "react";
import { MotionConfig } from "framer-motion";
import { newsArticles } from "./thtData";
import { Reveal, SectionHeading, FloatingDecor, PageMeta } from "./ThtParts";
import "./ThtTop.css";
import "./ThtDesign.css";
import "./ThtBusiness.css";
import "./ThtNews.css";
import "./ThtNatural.css";

const meta = {
  title: "ニュース｜THT合同会社",
  description: "THT合同会社の最新情報・お知らせをお届けします。",
  canonical: "https://tht-group.co.jp/news",
};

const ThtNews = () => (
  <>
    <PageMeta {...meta} />
    <MotionConfig reducedMotion="user">
      <div className="tht-home biz nws">
        <section className="biz-hero">
          <FloatingDecor />
          <div className="content-container">
            <SectionHeading en="News" ja="ニュース" />
            <Reveal delay={0.1}>
              <p className="lead-text">THT合同会社の最新情報・お知らせをお届けします。</p>
            </Reveal>
          </div>
        </section>

        <section className="biz-section nws-body">
          <FloatingDecor />
          <div className="content-container">
            {/* 新しい順に並べ、日付と内容を1行ずつ読みやすく */}
            <ul className="nws-list">
              {newsArticles.map((n, i) => (
                <Reveal key={n.id} delay={0.06 * i} x={-32} y={0}>
                  <li className="nws-item">
                    <time className="nws-date" dateTime={n.date.replace(/\./g, "-")}>
                      {n.date}
                    </time>
                    <p className="nws-title">{n.title}</p>
                  </li>
                </Reveal>
              ))}
            </ul>
            {newsArticles.length === 0 && <p className="nws-empty">現在お知らせはありません。</p>}
          </div>
        </section>
      </div>
    </MotionConfig>
  </>
);

export default ThtNews;
